"use client";

import styled from "styled-components";
import CaseDataLoader from "../CaseDataLoader/CaseDataLoader";
import Image from "next/image";
import DePuySynthesLogo from "@/assets/logos/DePuySynthes.svg";

const SplashContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 85vh;
  align-items: center;
  justify-content: center;
  gap: 50px;

  .message {
    display: flex;
    align-items: center;
    padding: 10px;
    font-size: 1.75rem;
    gap: 25px;
  }

  .mobile-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 1.25rem;
  }

  @media (max-width: 768px) {
    gap: 15px;

    .message {
      font-size: 1.5rem;
    }
  }
`;

const LogoWrapper = styled.div`
  width: 80%;
  max-width: 500px;

  @media (max-width: 768px) {
    max-width: 400px;
  }
`;

export default function Splash({
  message,
  showLoader = true,
}: {
  message: string;
  showLoader?: boolean;
}) {
  return (
    <SplashContainer>
      <LogoWrapper>
        <Image
          src={DePuySynthesLogo.src}
          alt="DePuy Synthes"
          width={1630}
          height={247}
          style={{ width: "100%", height: "auto" }}
        />
      </LogoWrapper>
      <div className="message">
        <p>{message}</p>
        {showLoader && <CaseDataLoader percent={null} size="50px" />}
      </div>
    </SplashContainer>
  );
}
